/**
 * @Description 围栏
 */

import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { FC, useEffect, useRef, useState } from 'react';
import { v4 } from 'uuid';
// import cs from 'classnames';
import styles from './index.module.less';
import ReactDOM from 'react-dom';
import { showMarker } from '@/common/utils/map';
import { RangeSelectEnum } from '../FirstScreenRight/ts-config';


const Rail: FC<any> = ({
  mapIns,
  detail,
  isBack,
  setIsBack,
  rangeMarkerRef,
  rangeSelectValue,
}) => {
  const curPolygonMarkerRef: any = useRef();// 当前开店区域围栏
  const circle500MarkerRef: any = useRef();
  const [isInit, setIsInit] = useState<boolean>(false);// 判断是否初始化绘制完成


  useEffect(() => {
    if (!mapIns) return;
    const {
      lng,
      lat,
      borders,
      radius,
    } = detail || {};

    if (!(+lng && +lat)) return;
    if (isArray(borders) && borders.length) {
      methods.createPolygon();
    } else if (radius > 0) {
      methods.createCircle(radius, false, true);
    }
    methods.createNameMarker();
    rangeMarkerRef.current.markerOf500 = methods.createCircle(500, true); // 5分钟步行圈
    rangeMarkerRef.current.markerOf1500 = methods.createCircle(1500); // 15分钟生活圈
    rangeMarkerRef.current.markerOf3000 = methods.createCircle(3000); // 外卖覆盖
    // 绘制是异步的
    setTimeout(() => {
      // 初始化绘制完成
      setIsInit(true);
    }, 100);
  }, [mapIns, detail]);

  useEffect(() => { // 点击了回到商圈
    if (!mapIns) return;
    // if (!circle500MarkerRef.current) return;
    if (isBack) {
      circle500MarkerRef.current && mapIns.setFitView(circle500MarkerRef.current, true, [40, 40, 40, 40], 20);
      setIsBack(false);
    }
  }, [mapIns, isBack]);

  const methods = useMethods({
    createPolygon: () => { // 绘制围栏
      const { borders } = detail;
      const polygonMarker = new window.AMap.Polygon({
        path: borders,
        fillColor: '#FFA31D',
        strokeOpacity: 1,
        fillOpacity: 0.12,
        strokeColor: '#FFA31D',
        strokeWeight: 2,
        strokeStyle: 'dashed',
        strokeDasharray: [2, 2],
      });

      mapIns.add(polygonMarker);
      curPolygonMarkerRef.current = polygonMarker;
    },
    /**
     *
     * @param radius 半径
     * @param needFitView 是否需要自适应地图
     * @param isDefault 是否当前围栏
     * @returns Marker对象：circleMarker、contentMarker
     */
    createCircle: (radius = 500, needFitView = false, isDefault = false) => { // 绘制圆形
      const { lng, lat } = detail;
      const circleMarker = new window.AMap.Circle({
        center: [+lng, +lat],
        radius, // 半径（米）
        strokeColor: isDefault ? '#FFA31D' : '#4792FD',
        strokeWeight: isDefault ? 2 : 0.5,
        strokeOpacity: 1,
        fillOpacity: isDefault ? 0.12 : 0,
        strokeStyle: isDefault ? 'dashed' : 'solid',
        strokeDasharray: [10, 10],
        fillColor: '#FFA31D',
      });
      mapIns.add(circleMarker);
      let contentMarker = null;
      if (!isDefault) {
        contentMarker = methods.createDistanceMarker(circleMarker, radius);
      }
      if (needFitView) {
        circle500MarkerRef.current = circleMarker;
        mapIns.setFitView(circleMarker, true, [40, 40, 40, 40], 20);
      }
      return {
        circleMarker,
        contentMarker
      };
    },
    createNameMarker: () => {
      const uid:any = v4();
      const { lng, lat, areaName } = detail;
      const marker = new window.AMap.Marker({
        position: new window.AMap.LngLat(+lng, +lat),
        anchor: 'top-center',
        offset: [0, -34],
        zIndex: 20
      });
      mapIns.add(marker); // 先添加到地图上
      marker.setContent(`<div id="${uid}"></div>`);
      ReactDOM.render(<div className={styles.textMarkerWrapper}>
        <div className={styles.textMarkerCon}>
          {areaName}
        </div>
      </div>, document.getElementById(uid));
    },

    // 不同距离围栏的标注 --  如果这里有修改，记得同时修改src/common/components/business/AreaDetailDrawer/components/FirstScreenRight/components/Basic.tsx里面的handleContentMarker
    createDistanceMarker: (circleMarker, radius) => {
      let content = '';
      switch (radius) {
        case RangeSelectEnum['100m']:
          content = '100m';
          break;
        case RangeSelectEnum['200m']:
          content = '200m';
          break;
        case RangeSelectEnum['300m']:
          content = '300m';
          break;
        case RangeSelectEnum['1km']:
          content = '1km';
          break;
        case 500:
          content = '500m(5分钟步行圈)';
          break;
        case 1500:
          content = '1.5km(15分钟生活圈)';
          break;
        case 3000:
          content = '3km(外卖覆盖)';
          break;
      }
      if (!content) return;
      // 获取最顶部的经纬度
      // ps 高德文档中的circleMarker没有getPath方法，但实际是可用的
      const topPosition = circleMarker.getPath().reduce((acc, item) => {
        if (acc.lat < item.lat) {
          acc = item;
        }
        return acc;
      });
      const marker = new window.AMap.Marker({
        position: topPosition,
        offset: [0, 10]
      });
      mapIns.add(marker);

      showMarker(marker, <div className={styles.distanceHint}>
        {content}
      </div>);
      return marker;
    }
  });

  // 当选择范围后，处理圈的大小
  // （1）当选择范围【不是】500m和围栏内时，会改变改变500m范围的半径和标题。
  // （2）当选择范围【是】500m或围栏内时，将markerOf500改回500m的范围和标题
  useEffect(() => {
    // 当初始化后才会执行。
    if (!rangeMarkerRef.current.markerOf500 || !isInit) return;

    // 当范围选择【不是】500m和围栏内时，会改变改变500m范围的半径和标题。
    if (![RangeSelectEnum.inPolygon, RangeSelectEnum['500m']].includes(rangeSelectValue)) {
      // 改变半径
      rangeMarkerRef.current.markerOf500?.circleMarker.setRadius(Number(rangeSelectValue));
      setTimeout(() => {
        mapIns.setFitView(rangeMarkerRef.current.markerOf500?.circleMarker, true, [40, 40, 40, 40], 20);
      }, 10);
      // 改变标题
      mapIns.remove(rangeMarkerRef.current.markerOf500?.contentMarker);
      rangeMarkerRef.current.markerOf500.contentMarker = null;
      rangeMarkerRef.current.markerOf500.contentMarker = methods.createDistanceMarker(rangeMarkerRef.current.markerOf500?.circleMarker, Number(rangeSelectValue));
    } else {
      // 当范围选择【是】500m或围栏内时，将markerOf500改回500m的范围和标题
      // 恢复半径
      rangeMarkerRef.current.markerOf500?.circleMarker.setRadius(500);
      setTimeout(() => {
        mapIns.setFitView(rangeMarkerRef.current.markerOf500?.circleMarker, true, [40, 40, 40, 40], 20);
      }, 10);
      // 恢复标题
      mapIns.remove(rangeMarkerRef.current.markerOf500?.contentMarker);
      rangeMarkerRef.current.markerOf500.contentMarker = null;
      rangeMarkerRef.current.markerOf500.contentMarker = methods.createDistanceMarker(rangeMarkerRef.current.markerOf500?.circleMarker, 500);
    }
  }, [rangeSelectValue, isInit]);

  return (
    <></>
  );
};

export default Rail;


